<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Casco',
  mounted() {
    let script = document.createElement('script');
    script.src = 'https://kasko.insapp.ru/app/assets/scripts/iframe_loader.js';
    script.setAttribute('data-apikey', '1b0751bd685b4ffeb170f07a7e8f4757');
    script.setAttribute('data-theme', 'dark');
    script.setAttribute('data-modelid', 'ModelId');
    script.setAttribute('data-cpaclientuid', 'cpaClientUid');
    script.setAttribute('data-webmasterid', 'webmasterId');
    script.setAttribute('data-platformid', 'platformId');
    script.setAttribute('data-partnerbrandname', 'brand');
    script.setAttribute('data-partnermodelname', 'Model');
    this.$refs.script.appendChild(script);
  },
  computed: {
    ...mapGetters({
      allShowedOverlays: 'Popups/allShowedOverlays',
    }),

    isShowedPopup() {
      return this.allShowedOverlays?.includes('casco');
    },
  },
  methods: {
    ...mapActions({
      togglePopup: 'Popups/togglePopup',
    }),
    
    closePopup() {
      this.togglePopup('casco');
    },
  },
};
</script>

<template>
  <div
    class="popup-new"
    :class="{ 'opacity-100 visible': isShowedPopup }"
    @click.self="closePopup"
  >
    <div class="popup-new-inner">
      <div class="w-full">
        <div class="flex items-center justify-between mb-2.5 md:mb-5">
          <img src="/public/images/logo.svg" alt="" class="w-full max-w-[186px] h-[41px] pr-2">
          <div
            class="popup-new__close"
            @click="closePopup"
          ></div>
        </div>
        <div
          ref="script"
          class="mb-8"
        ></div>
      </div>
    </div>
  </div>
</template>